import Loader from "@/components/ui/Loader/Loader";
import { LoadingOverlay } from "@mantine/core";
import { useRouterState } from "@tanstack/react-router";
import type { ReactNode } from "react";

const FIRST_LOAD_LOADER_PROPS = {
  children: <Loader withContainer={false} size="medium" />,
};

// SERV-3371: AppLayout's overlay only mounts once the root route has loaded, so a fresh load (new
// tab, refresh) shows a blank page until then. This covers that first load from the router's
// InnerWrap. A root pendingComponent would look the same, but the router throws when a beforeLoad
// redirect (e.g. to /login) lands after its pending screen has shown.
function FirstLoadOverlay({ children }: { children: ReactNode }) {
  const isFirstLoad = useRouterState({ select: (state) => !state.resolvedLocation });

  return (
    <>
      <LoadingOverlay visible={isFirstLoad} loaderProps={FIRST_LOAD_LOADER_PROPS} />
      {children}
    </>
  );
}

export default FirstLoadOverlay;
